import { render } from "./bookUmrah.vue?vue&type=template&id=58592662&scoped=true"
import script from "./bookUmrah.vue?vue&type=script&lang=js"
export * from "./bookUmrah.vue?vue&type=script&lang=js"

import "./bookUmrah.vue?vue&type=style&index=0&id=58592662&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58592662"]])

export default __exports__